module.exports = __webpack_public_path__ + "static/media/close.e01c7808.svg";